export const version = '0.795.1'
export const chameleonWebVersion = '9.19.0'
export const chameleonCoreVersion = '7.12.0'
